import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin(() => {
  function randomNumber(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getInitials(fullName: string): string {
    return fullName
      ? fullName
          .split(' ')
          .map((n) => n[0])
          .join('')
          .toUpperCase()
          .substring(0, 3)
      : 'L';
  }

  return {
    provide: {
      randomNumber,
      getInitials,
    },
  };
});
